import React from "react";
import ISelect from "../ISelect";
import Constants from "../../constants/Common";

import style from "./index.module.scss";

type SelectCountPerPageProps = {
  optionsArr: { title: string; id: number }[];
  additionalText: string;
  allowClear: boolean;
  onChange: () => void;
  onClear: () => void;
  value: string | number;
};

const SelectCountPerPage: React.FC = ({
  optionsArr,
  onChange,
  onClear,
  value,
  allowClear = true,
  additionalText = "Показывать по:",
}: SelectCountPerPageProps) => {
  const optionsInner = optionsArr ?? Constants.perPageOptions;

  return (
    <div className={style.PerPageCounter}>
      <span className={style.PerPageCounterLabel}>{additionalText}</span>
      <ISelect
        value={value}
        optionsArr={optionsInner}
        onChange={onChange}
        type="small"
        className={style.PerPageSelect}
      />
    </div>
  );
};

export default SelectCountPerPage;
